export default {
    my_domains: 'Domains',
    my_invoices: 'Invoices',
    my_cloud_hosting: 'Cloud Hosting',
    my_shared_hosting: 'Shared Hosting',
    my_cloud_server: 'Cloud Server',
    my_transactions: 'Transactions',
    expired_date: 'Expired Date',
    dashboard: 'Dashboard',
    welcome:
        '<span class="text-primary">Welcome</span> to your 1Byte Client Dashboard!',
    service: 'Your Services at <span class="text-primary">1Byte</span>',
    service_subtitle: 'Manage your services quickly and easily with us!',
    total_domains: 'Total Domains',
    total_cloud_hosting: 'Total Cloud Hosting',
    total_cloud_server: 'Total Cloud Server',
    total_shared_hosting: 'Total Shared Hosting',
    total_wordpress_hosting: 'Total WordPress Hosting',
    total_ssl: 'Total SSL Certificates',
};
